module.exports = ".alignClose {\n  margin-top: 1em; }\n\n.meterstyle {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px; }\n"